import React from 'react';
import { TrashBinIcon } from '@rsos/assets/icons';
import { Box, Button, Modal, Text } from '@rsos/components/capstone/base';
import {
  ModalFooter,
  ModalBody,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import { EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import { IconWrapper } from './RemoveAllEventsModal.styles';

const RemoveAllEventsModalLegacy = ({
  activeQueueTab,
  isOpened,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={340}
      id="remove-all-events-modal"
      data-name="remove-all-events-modal"
    >
      <ModalBody onClose={onClose}>
        <Box horizontal flow={20}>
          <IconWrapper>
            <TrashBinIcon
              height={42}
              width={35}
              viewboxWidth={140}
              viewboxHeight={140}
            />
          </IconWrapper>
          <Text size="xlarge" color="lightDanger">
            Do you want to{' '}
            <Text fontWeight="bold" inline>
              {`remove all ${
                activeQueueTab === EMERGENCY_CALLS ? '911' : 'alerts'
              } events?`}
            </Text>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter flow={12}>
        <Button
          btnType="tertiary"
          onClick={onClose}
          grow
          noMargin
          data-name="cancel-button"
        >
          Cancel
        </Button>
        <Button
          data-name="remove-all-button"
          btnType="warning_primary"
          onClick={onConfirm}
          grow
          noMargin
        >
          Yes, Remove All
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveAllEventsModalLegacy;
